<template>
    <dv-capsule-chart :config="config" style="width:300px;height:200px" />
  </template>
  
  <script>
  export default {
    name: "AreaRanking",
    data() {
      return {
        config: {},
      }
    },
    methods:{
    },
    mounted() {
    },
    created() {
     
       let data=[];
       data[0]={'name':"驿城区",'value':100};
       data[1]={'name':"上蔡县",'value':118};
       data[2]={'name':"新蔡县",'value':30};
       data[3]={'name':"西平县",'value':40};
       data[4]={'name':"泌阳县",'value':50};
       data[5]={'name':"平舆县",'value':50};
       data[6]={'name':"汝南县",'value':80};
    //    data[7]={'name':"确山县",'value':60};
    //    data[8]={'name':"正阳县",'value':20};
    //    data[9]={'name':"遂平县",'value':50};
        
        this.config = {
          data: data,
          colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
          unit: '亩',
          showValue: true
        }
  
    },
    watch: {
      message(value) {
        this.init();
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>